var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1472"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 363",
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a8.779 8.779 0 01-3.517-.711 8.938 8.938 0 01-4.772-4.772 9.06 9.06 0 010-7.034 8.938 8.938 0 014.772-4.772 9.06 9.06 0 017.034 0 8.938 8.938 0 014.772 4.772 9.06 9.06 0 010 7.034 8.938 8.938 0 01-4.772 4.772A8.779 8.779 0 0112 21zm-.995-1.113v-1.919a1.824 1.824 0 01-1.386-.592 2 2 0 01-.557-1.421v-1.018l-4.783-4.761q-.095.45-.154.9a7.075 7.075 0 00-.059.924 7.746 7.746 0 001.978 5.282 7.588 7.588 0 004.961 2.605zm6.845-2.511a7.728 7.728 0 00.888-1.184 8.667 8.667 0 00.663-1.326 7.354 7.354 0 00.4-1.409A8.191 8.191 0 0019.934 12a7.917 7.917 0 00-1.35-4.488 7.773 7.773 0 00-3.624-2.949v.45a2.014 2.014 0 01-.56 1.409 1.807 1.807 0 01-1.386.6h-2.009v2.013a.831.831 0 01-.308.663 1.068 1.068 0 01-.711.261H8.045V12h5.992a.844.844 0 01.663.3 1.023 1.023 0 01.261.7v2.961h.995a1.908 1.908 0 011.2.391 1.967 1.967 0 01.7 1.03z",
    fill: "#444"
  }))));
}
export default SvgWebsite;